
 <template>
    <div>
        <div v-if="!isLoaded" class="loading-bar"></div>
        <!--<div v-if="!isLoaded" style="margin: auto; height: 20px" class="mdl-grid">
            <div class="mdl-spinner mdl-js-spinner is-active" style="height: 20px; width: 5rem"></div>
        </div>-->
        <!--<div class="mdi mdi-refresh rotating"
                        style="margin-left: 8px;display: inline-block;"></div>-->
                        
                        
        <DatePicker :datum="datum" @date-change="dateChanged" :disabled="!isLoaded"></DatePicker>
        <div class="mdl-grid mdl-shadow--4dp table-large no-padding" style="margin-bottom: 1em">
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--hide-phone header-cell">Jméno</div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--hide-phone header-cell">Jídlo</div>
            <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--1-col-tablet mdl-cell--hide-phone header-cell">Příloha</div>
            <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--1-col-tablet mdl-cell--hide-phone header-cell">Polévka</div>
            <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--hide-phone header-cell">Objednal</div>


            <div v-for="(order, index) in orders" :key="order.orderedForUser.userId" style="width: 100%" class="mdl-grid row" :class="{'odd-row' : index % 2 === 0}" v-on:click="openModal(order.orderedForUser)">
                    <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--2-col-phone cell">{{ order.orderedForUser.name }}</div>
                    <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone cell">{{ getFoodCode(order) }}</div>
                    <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--1-col-tablet mdl-cell--hide-phone cell">{{ getFoodOptionNames(order) }}</div>
                    <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--1-col-tablet mdl-cell--1-col-phone cell">{{ getSoupCode(order) }}</div>
                    <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--hide-phone cell">{{ getOrderedBy(order) }}</div>
            </div>

            <Modal ref="modal" :open-counter="this.openCounter" :title="selectedUser.name">
                <div v-if="!isLoaded" class="loading-bar"></div>
                <div class="mdl-grid">
                    <h5 class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone">
                        Objednáváte pro uživatele {{selectedUser.name}}
                    </h5>

                    <div class="mdl-cell mdl-cell--4-col mdl-cell--col-desktop mdl-cell--5-offset-desktop mdl-cell--2-offset-tablet center">
                        <button :disabled="!isLoaded" class="mdl-button material-icons date-icon mdi mdi-calendar-minus" @click="addDays(-1)"></button>&nbsp;&nbsp;&nbsp;
                        <span style="font-size: 15pt">{{ datum.getDate() }}.{{ datum.getMonth() + 1 }} {{ datum.getUTCFullYear() }}&nbsp;&nbsp;&nbsp;</span>
                        <button :disabled="!isLoaded" class="mdl-button material-icons date-icon mdi mdi-calendar-plus" @click="addDays(1)"></button>
                    </div>

                    <MenuList :food="orderedFood"
                              :soup="orderedSoup"
                              :for-user="forUser"
                              :day="this.date"
                              :menus="menus"
                              :order-counts="orderCounts"
                              v-on:ordered-food="load()"
                              v-on:snack="snack"
                              :disabled="!isLoaded"
                              class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone">
                    </MenuList>
                </div>
            </Modal>
        </div>
        <snackbar :open-counter="snackbarCounter">
            {{ snackbarMessage }}
        </snackbar>
    </div>
</template>

<script>
    import Modal from "../components/widgets/Modal";
    import axios from "axios"
    import config from "../config"
    import MenuList from "../components/MenuList";
    import DatePicker from "../components/widgets/DatePicker";
    import Snackbar from "../components/widgets/Snackbar";

    export default {
        name: "LunchSummary",
        components: {Snackbar, DatePicker, MenuList, Modal },
        data: function () {
            return {
                openCounter: 0,
                orders: Array,
                selectedOrder: Object,
                selectedUser: Object,
                lastChangeBy: null,
                date: new Date().toISOString().substr(0, 10),
                menus: [],
                snackbarCounter: 0,
                snackbarMessage: "",
                orderCounts: null,
                loaded: true
            }
        },
        methods: {
            openModal: function (user) {
                if (this.isLoaded) {
                    this.selectedUser = user;
                    this.findOrderForSelectedUser();
                    this.openCounter++;
                }
            },
            load: function () {
                this.loaded = false
                this.loadOrders();
                this.loadMenu();
            },
            loadOrders: function() {
                //this.orders = []
                axios
                    .get(config.host + "/v1/order/all/" + this.date)
                    .then(response => {
                        //window.console.log(response)
                        this.orders = response.data;
                        if(this.user !== null)
                            this.findOrderForSelectedUser();

                      const codes = {}
                      response.data
                          .filter(order => order.orderedFood != null)
                          .map(order => order.orderedFood.foodCode)
                          .forEach(code => codes[code] === undefined ? codes[code] = 1 : codes[code] += 1)
                      this.orderCounts = []
                      for (const code in codes)
                        this.orderCounts.push({code, count: codes[code]})
                      this.orderCounts = this.orderCounts.sort((a, b) => b.count - a.count)
                      this.loaded = true
                    })
                    // eslint-disable-next-line no-unused-vars
                    .catch(reason => {
                        this.loaded = true
                        return (window.setTimeout(this.loadOrders, 5000));
                    });
            },
            loadMenu: function() {
                //this.loaded = false
                axios
                    .get(config.host + "/v1/menu/" + this.date)
                    .then(response => {
                        if (Array.isArray(response.data))
                            this.menus = response.data
                    })
                    // eslint-disable-next-line no-unused-vars
                    .catch(reason => {
                        window.setTimeout(this.loadMenu, 5000)
                    });
            },
            getSoupCode: function (order) {
                if(order === undefined  || order.orderedSoup === undefined || order.orderedSoup === null)
                    return '-';
                else
                    return order.orderedSoup.soupCode;
            },
            getFoodCode: function (order) {
                if(order === undefined  || order.orderedFood === undefined || order.orderedFood === null)
                    return '-';
                else
                    return order.orderedFood.foodCode;
            },
            getFoodOptionNames: function (order) {
                if(order === undefined  || order.orderedFoodOptions === undefined || order.orderedFoodOptions === null)
                    return '-';
                else {
                    return order.orderedFoodOptions.map(option => option.foodOptionType.name).join(', ');
                }
            },
            getOrderedBy: function(order) {
                if(order === undefined  || order.orderedByUser === undefined || order.orderedByUser === null)
                    return '-';
                return order.orderedByUser.name
            },
            findOrderForSelectedUser: function () {
                this.orders.forEach (order => {
                    if(order.orderedForUser.userId === this.selectedUser.userId)
                        this.selectedOrder = order;
                });
            },
            dateChanged: function (date) {
                this.date = new Date(date).toISOString().substr(0, 10);
                this.load();
            },
            snack: function(message) {
                this.snackbarMessage = message;
                this.snackbarCounter++;
            },
            isAdmin: function () {
                return localStorage.getItem("keycloak-is-admin") === "true";
            },
            addDays: function (days) {
                const d = new Date(this.date);
                d.setDate(d.getDate() + days);
                this.date = d.toISOString().substr(0, 10);
                this.load();
            }
        },
        mounted() {
            this.openCounter = 0;
            this.load();
            window.setInterval(this.load, 60000);
        },
        computed: {
            isLoaded() {
                return this.loaded
            },
            isMobile: function () {
                return window.innerWidth < 768;
            },
            forUser: function () {
                if (this.selectedUser !== null && this.selectedUser !== undefined)
                    return this.selectedUser.userId;
                else
                    return "";
            },
            orderedFood: function () {
                if (this.selectedOrder !== null && this.selectedOrder !== undefined) {
                    return { orderedFood: this.selectedOrder.orderedFood, foodOptions: this.selectedOrder.orderedFoodOptions };
                } else
                    return null;
            },
            orderedSoup: function () {
                if (this.selectedOrder !== null && this.selectedOrder !== undefined)
                    return { orderedSoup: this.selectedOrder.orderedSoup };
                else
                    return null;
            },
            datum: function () {
                return new Date(this.date);
            },
        }
    }
</script>

<style scoped>
.rotating {
  animation: mymove 1s linear infinite;
}

.loading-bar {
  height: 5px;
  width: 40%;
  background-color: #FFB333;
  position: absolute;
  top: 0px;
  left: -20%;
  animation: loading 3s ease-in-out 0s infinite;
  z-index: 100;
}

@keyframes loading {
 from {
  transform:translateX(0)
 }
 30% {
  transform:translateX(230%)
 }
}

@keyframes mymove {
    from {
        transform: rotate(-360deg);
    }
}

    .table-large {
        margin: 1rem auto auto;
        color: #666666;
        font-weight: 300;
        width: 90%;
    }

    .odd-row {
        background: #F6F6F6;
    }

    .row {
        cursor: pointer;
    }

    .row:hover {
        background: #999999;
        color: white;
    }

    .cell {
        margin-top: auto;
        margin-bottom: auto;
        text-align: center;
    }

    .header-cell {
        margin-top: 1em;
        margin-left: 1em;
        margin-right: auto;
        text-align: center;
        color: #666666;
        font-weight: bold;
    }

    .no-padding {
        padding: 0;
    }

    .date-icon {
        font-size: 15pt;
    }

    .date-icon:hover {
        cursor: pointer;
    }
</style>